/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 2332
// module chunks = 0